/**
 * Trade Dashboard — approval-status polling for pre-approved users.
 *
 * Loaded by sections/trade-dashboard.liquid.
 * Polls /apps/trade/users/approval-status every 4 s until approved
 * or a 2-minute timeout is reached, then reloads the page.
 */
(function () {
	document.addEventListener('DOMContentLoaded', function () {
		const page = document.getElementById('trade-dashboard-page');
		if (!page) return;

		const isPreApproved = page.dataset.preApproved === 'true';
		if (!isPreApproved) return;

		const modal = document.getElementById('approval-polling-modal');
		const loadingEl = document.getElementById('approval-polling-loading');
		const timeoutEl = document.getElementById('approval-polling-timeout');
		let pollInterval = null;
		const startTime = Date.now();
		const POLL_DELAY = 4000;
		const TIMEOUT = 120000;

		function isOnboardingActive() {
			const onboarding = document.getElementById('trade-onboarding-modal');
			return onboarding && onboarding.style.display !== 'none';
		}

		function checkStatus() {
			tradeFetch(window.tradeApiBase + '/users/approval-status', undefined, {
				source: 'TradeDashboard.checkApprovalStatus',
			})
				.then(function (res) {
					return res.json();
				})
				.then(function (data) {
					if (!data.invited) {
						modal.classList.add('modal-overlay--hidden');
						if (pollInterval) clearInterval(pollInterval);
						return;
					}

					if (data.approved) {
						if (pollInterval) clearInterval(pollInterval);
						if (window.Shopify && window.Shopify.designMode) return;
						if (isOnboardingActive()) {
							const waitForOnboarding = setInterval(function () {
								if (!isOnboardingActive()) {
									clearInterval(waitForOnboarding);
									window.location.reload();
								}
							}, 500);
						} else {
							window.location.reload();
						}
						return;
					}

					if (!isOnboardingActive()) {
						modal.classList.remove('modal-overlay--hidden');
					}

					if (Date.now() - startTime > TIMEOUT) {
						if (pollInterval) clearInterval(pollInterval);
						loadingEl.style.display = 'none';
						timeoutEl.style.display = 'flex';
					}
				})
				.catch(function (error) {
					if (window.trackTradeError) trackTradeError(error, { source: 'TradeDashboard.checkApprovalStatus' });
					if (Date.now() - startTime > TIMEOUT) {
						if (pollInterval) clearInterval(pollInterval);
						loadingEl.style.display = 'none';
						timeoutEl.style.display = 'flex';
					}
				});
		}

		checkStatus();
		pollInterval = setInterval(checkStatus, POLL_DELAY);
	});
})();
